var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F0F3FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.571 15.857h12.857v2.572H5.571zm5.572-11.143h1.285v9.858h-1.285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.067 8.143h2.344s.026-.142.017-.356c-.034-.703-.342-2.215-3.492-2.215c-3.489 0-3.558 2.104-3.558 2.417c0 .244-.141 1.795 1.912 2.314c2.057.518 2.996.57 2.996 1.329c0 .762-.665.985-1.218.985c-.557 0-1.354-.056-1.354-1.046H8.143s-.18 2.572 3.793 2.572c3.972 0 3.921-2.4 3.921-2.764c0-.343-.077-1.685-2.331-2.242c-2.25-.557-2.812-.566-2.812-1.35c0-.643.892-.715 1.329-.715c.313 0 1.024-.005 1.024 1.07"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusd);
export default __webpack_public_path__ + "static/media/musd.ce5e325c6deccffa8d27d6735cd5b404.svg";
export { ForwardRef as ReactComponent };